import DummyRouter from '@/features/ui/components/DummyRouter.vue'
import { PermissionActions } from '@/features/permissions/permissionActions.js'

export const trackingRoutes = [
  {
    path: 'tracking',
    component: DummyRouter,
    meta: {
      layoutPadding: false,
      permissionAction: PermissionActions.TrackingView,
    },
    children: [
      {
        path: '',
        component: () => import('@/features/tracking/trackingRoot/TrackingRootView.vue'),
        meta: { permissionAction: PermissionActions.TrackingView },
      },
      {
        path: ':trackingHubId',
        component: () =>
          import('@/features/tracking/trackingRoot/detail/TrackingHubDetailView.vue'),
        meta: { permissionAction: PermissionActions.TrackingHubsView },
      },
      {
        path: ':trackingHubId/settings',
        component: () =>
          import('@/features/tracking/trackingRoot/detail/advancedHubConfiguration/TrackingHubDetailHubAdvancedConfig.vue'),
        meta: { permissionAction: PermissionActions.TrackingHubsView },
      },
      {
        path: 'certificate-editor',
        component: () => import('@/features/tracking/certificateEditor/CertificateEditorView.vue'),
        meta: { permissionAction: PermissionActions.TrackingCertificatesView },
      },
      {
        path: ':trackingHubId/reports',
        component: () =>
          import('@/features/tracking/trackingRoot/detail/reports/TrackingHubReports.vue'),
        meta: { permissionAction: PermissionActions.TrackingReportsView },
      },
      {
        path: ':trackingHubId/reports/item',
        component: () =>
          import('@/features/tracking/trackingRoot/detail/reports/TrackingHubReportsItem.vue'),
        meta: { permissionAction: PermissionActions.TrackingReportsView },
      },
      {
        path: ':trackingHubId/reports/progress',
        component: () =>
          import('@/features/tracking/trackingRoot/detail/reports/TrackingHubReportsProgress.vue'),
        meta: { permissionAction: PermissionActions.TrackingReportsView },
      },
      {
        path: ':trackingHubId/reports/date',
        component: () =>
          import('@/features/tracking/trackingRoot/detail/reports/TrackingHubReportsDate.vue'),
        meta: { permissionAction: PermissionActions.TrackingReportsView },
      },
      {
        path: ':trackingHubId/reports/value',
        component: () =>
          import('@/features/tracking/trackingRoot/detail/reports/TrackingHubReportsValue.vue'),
        meta: { permissionAction: PermissionActions.TrackingReportsView },
      },
      {
        path: ':trackingHubId/org-report',
        component: () =>
          import('@/features/tracking/trackingRoot/detail/reports/org-report/TrackingHubReportsOrg.vue'),
        meta: { permissionAction: PermissionActions.TrackingReportsOrganizationView },
      },
      {
        path: ':trackingHubId/profile-assign',
        component: () =>
          import('@/features/tracking/trackingRoot/detail/profileAssign/TrackingHubProfileAssign.vue'),
        meta: { permissionAction: PermissionActions.TrackingAssigneesManage },
      },
      {
        path: 'springboard/:tenantGroupId',
        component: () =>
          import('@/features/tracking/trackingRoot/detail/promote/TrackingHubDetailPromote.vue'),
        meta: {
          layoutPadding: true,
          permissionAction: PermissionActions.TrackingPromoteView,
        },
      },
    ],
  },
]
